import useSyncedLocalStorage from './useSyncedLocalStorage';

export default function useSessionId() {
  return useSyncedLocalStorage('rpSessionId');
}
